/**
 * Middleware to avoid the users with 'parent' or 'child' role from accessing the page.
 * When a parent or child user comes, navigate to parent or learner dashboard page respectively.
 */
export default defineNuxtRouteMiddleware(() => {
  let userRole: string;
  let isChildUser: boolean;

  if (import.meta.server) {
    const event = useRequestEvent();

    userRole = event?.context?.session?.role;
    isChildUser = userRole === 'student' && !event?.context?.session?.email;
  } else {
    userRole = useAuthenticateStore()?.role;
    isChildUser = userRole === 'student' && !useAuthenticateStore()?.email;
  }
  if (userRole === 'parent') {
    return navigateTo({ path: '/parent/dashboard' });
  } else if (isChildUser) {
    return navigateTo({ path: '/learner/dashboard' });
  }
});
